import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: "rs",
    lng: "rs",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          cookieConsent: {
            title: "This website uses cookies to enhance the user experience.",
            description:
              "We use cookies to analyze website traffic and optimize your experience on the website. By accepting our use of cookies, your data will be aggregated with all other user data.",
            understand: "I understand",
          },
          validation: {
            validationCompanyName: "Company name field is required",
            validationTaxId: "Tax-Id field is required",
            validationEmail: "E-mail field is required",
            validationPhoneNumber: "Phone number field is required",
            validationMessage: "Message field is required",
            validationPackage: "Choose a package",
          },
          messageKey: {
            orderRequest_Pending: "Sending order request...",
            orderRequest_Success:
              "The order request has been successfully sent!",
            orderRequest_Error:
              "Unfortunately, the request could not be sent. Please check your internet connection and try again.",

            advertisementRequest_Pending: "Sending advertising request...",
            advertisementRequest_Success:
              "The advertising request has been successfully sent!",
            advertisementRequest_Error:
              "Unfortunately, the request could not be sent. Please check your internet connection and try again.",

            updateDataRequest_Pending: "Slanje zahtjeva za ažuriranje...",
            updateDataRequest_Success:
              "Zahtjev za ažuriranje je uspješno poslan!",
            updateDataRequest_Error:
              "Unfortunately, the request could not be sent. Please check your internet connection and try again.",

            contactRequest_Pending: "Vaša poruka se šalje... ",
            contactRequest_Success:
              "Vaš zahtjev je uspješno poslan! Hvala vam što ste nas kontaktirali. Potrudit ćemo se da vam odgovorimo u najkraćem mogućem roku.",
            contactRequest_Error:
              "Unfortunately, sending the message failed. Please check your internet connection and try again.",
          },
          header: {
            homePage: "Home",
            services: "Services",
            updateData: "Updating Data",
            advertisement: "Advertising",
            digitalMarketing: "Digital Marketing",
            editions: "Editions",
            aboutUs: "About Us",
            contact: "Contact",
            companyNameInput:
              "Enter company name, service/product, location...",
            advanceSearchLabel: "Advanced search of Business Directory BiH",
            categoryInput: "Category",
            subCategoryInput: "Subcategory",
            place: "Place",
          },
          footer: {
            footerDescription:
              "The primary activity of our company is business publishing in the territory of Bosnia and Herzegovina. Our editorial team has successfully launched numerous highly circulated specialized business publications, including the Telephone-telefax Directory of BiH, Telefonoteka, Business Directory of BiH, 300 Most Successful Companies in BiH, Catalog of Business Directory of BiH, as well as corresponding electronic publications on CD, and accompanying online editions for these titles.",
            footerFastLinksTitle: "Fast links",
            footerFastLinkHome: "Home",
            footerFastLinkServices: "Services",
            footerFastLinkUpdatingData: "Updating Data",
            footerFastLinkAdvertisement: "Advertising",
            footerFastLinkDigitalMarketing: "Digital Marketing",
            footerFastLinkEditions: "Editions",
            footerFastLinkAbout: "About Us",
            footerFastLinkContact: "Contact us",
          },
          homePage: {
            resultsPerPage: "Reuslts per page",
          },
          updatingDataPage: {
            updatingDataTitle: "Updating Data",
            updatingDataText:
              "The process of updating data in the Business Directory of Bosnia and Herzegovina involves modifying existing information, adding new entries, and removing outdated or invalid data from the database. This task is performed by the publisher, who gathers information through fieldwork, telephone surveys, and online submissions via the website's form.",
            updatingDataFormCompanyName: "Company name",
            updatingDataFormPIB: "TAX-ID",
            updatingDataFormEmail: "E-mail",
            updatingDataFormPhoneNumber: "Phone number",
            updatingDataFormPlace: "Place",
            updatingDataFormStreet: "Street",
            updatingDataFormHomeNumber: "Home number",
          },
          advertisementPage: {
            advertisementTitle: "Advertising",
            advertisementText:
              "We provide various types of advertising and create a set of services tailored to the needs of our clients. For a complete range of our services and personalized creation of an advertising services set, it is necessary to contact our sales agents. You can also order some of our most popular service packages via the following contact form.",
            advertisementFormCompanyName: "Company name",
            advertisementFormPIB: "TAX-ID",
            advertisementFormEmail: "E-mail",
            advertisementFormPhoneNumber: "Phone number",
            advertisementFormPlace: "Place",
            advertisementFormStreet: "Street",
            advertisementFormHomeNumber: "Home number",
          },
          digitalMarketingPage: {
            digitalMarketingTitle: "Digital Marketing",
            digitalMarketingText:
              "We provide comprehensive solutions for a company's business information, advertising, and digital transformation. Leveraging intelligent software technologies, we offer high-quality, efficient, and affordable solutions to enhance digital business and drive increased success.",
            digitalMarketingTextSecond:
              "Our approach begins with analyzing your business processes and information systems to propose optimal solutions for digital transformation, integration, automation, and improvement across all business segments. Our solutions are unique, dynamic, and scalable, fully customized to meet your specific needs and goals.",
            digitalMarketingTextThird:
              "We stay up-to-date with the latest technological trends and implement our services in accordance with best practices. Whether youre embarking on a new project, expanding existing operations, or seeking to enhance your online presence, we are here to assist you. Get in touch with us to request a free assessment of your digital business improvement possibilities, and we will provide you with tailored suggestions for digital business development aligned with your needs and goals.",
          },
          editionsPage: {
            catalogTitle: "Business Directory of BiH - Catalog",
            catalogTextFirst:
              "The Business Directory of Bosnia and Herzegovina (printed edition) held the distinction of being the most widely read and best-selling business information publication in the country until 2016. Its long- standing presence in the business landscape has made it well-known to companies, organizations, and institutions that have directly or indirectly benefited from the information provided in its annual editions. Business Directory BiH can be searched on the website www.poslovniimenik.net.",
            catalogText:
              "The Business Directory of Bosnia and Herzegovina (printed edition) held the distinction of being the most widely read and best-selling business information publication in the country until 2016. Its long- standing presence in the business landscape has made it well-known to companies, organizations, and institutions that have directly or indirectly benefited from the information provided in its annual editions of the Business Directory BiH can be searched on the website www.poslovniimenik.net.",
            catalogTextSecond:
              "The Business Directory BiH - Catalog primarily focuses on companies, organizations, and institutions operating within the territory of Bosnia and Herzegovina. These entities vividly showcase themselves through colorful advertisements and descriptive text within this publication.",
            catalogTextThird:
              "Like previous editions of the Business Directory of Bosnia and Herzegovina - Catalog, this publication adheres to the established concept of direct marketing, emphasizing active legal entities from Bosnia and Herzegovina. In the Catalog, advertisements of legal entities are categorized based on related activities, while advertisers with logos from the same industry are listed alphabetically within each ad section. More comprehensive information about companies and institutions can be found in the Catalog (in PDF format), and the entire database of the Business Directory BiH can be searched on the website www.poslovniimenik.net.",
            cdTitle:
              "Business Directory of Bosnia and Herzegovina - digital edition",
            cdText:
              "Compared to the online and print editions, the electronic edition of the Business Directory of Bosnia and Herzegovina offers numerous advantages. These advantages are particularly evident in the search and sorting functionalities, allowing users to search by various individual parameters, conduct combined searches using multiple criteria, and save and store searches.",
            cdTextSecond:
              "Another significant advantage is the ability to utilize the data for digital marketing purposes, such as social media or direct marketing campaigns. The database of the Electronic Business Directory of Bosnia and Herzegovina is updated daily and enriched with new information concerning both existing and newly established companies and institutions.",
            cdTextThird:
              "For each company or institution listed in the database, the following basic information is provided: - Company or institution name - Details about the company or institutions activities - Address, including street, number, city, postal code, entity, and telephone number with country code - Telephone numbers, fax numbers, and email addresses - Website addresses of the company or institution",
            cdTextFourth:
              "By purchasing the electronic edition of the Business Directory of Bosnia and Herzegovina and adding your company to the database, you gain the privilege of having your information listed and published in both the online and electronic editions of the Business Directory. Furthermore, you are entitled to free regular updates, changes, or additions to your data via the internet throughout a one-year subscription period.",
            cdTextFifth:
              "We firmly believe that this electronic edition of the Business Directory of Bosnia and Herzegovina will provide you with convenient access to all the necessary data for seamless communication, facilitating the establishment of business contacts with existing legal entities in Bosnia and Herzegovina.",
            onlineTitle: "Online Business Directory of Bosnia and Herzegovina",
            onlineText:
              "The online edition of the Business Directory of Bosnia and Herzegovina serves as a central hub for various business activities. The website, www.poslovniimenik.net, provides its content to all internet users, allowing easy browsing and quick data searches using a variety of parameters. Our website attracts a substantial number of daily visitors, including a diverse range of individuals and business users, providing substantial benefits to both our visitors and service users.",
            onlineTextSecond:
              "By showcasing your company, institution, or organization on our website, you join a community of advertisers who have already highlighted their information through advertisements.",
            onlineTextThird:
              "This exposure allows hundreds of thousands of interested visitors to gain a comprehensive overview of your company and its activities. The online edition of the Business Directory of Bosnia and Herzegovina, in conjunction with its printed and electronic counterparts, aims to provide essential business information to users across all categories and actively influence the flow of information through its dynamic nature.",
            onlineTextFourth:
              "The publisher diligently collects and regularly updates all information obtained through field and phone surveys, as well as from other reliable sources. This ensures that the information about your company will be swiftly available on the online presentation of the Business Directory of Bosnia and Herzegovina.",
            onlineTextFifth: "",
          },
          aboutUsPage: {
            aboutTitle: "About Us",
            aboutText:
              "The primary activity of our company is business publishing in the territory of Bosnia and Herzegovina. Our editorial team has successfully launched numerous highly circulated specialized business publications, including the Telephone-telefax Directory of BiH, Telefonoteka, Business Directory of BiH, 300 Most Successful Companies in BiH, Catalog of Business Directory of BiH, as well as corresponding electronic publications on CD and accompanying online editions for these titles.",
            aboutTextSecond:
              "Our business strategy revolves around direct marketing and direct sales. Through these strategies, the publisher of the Business Directory of Bosnia and Herzegovina independently organizes all commercial and marketing activities, as well as the preparation, editing, and publishing of our business publications.",
            aboutTextThird:
              "This business concept is the foundation of our mission, which is to actively and continuously update the database of economic entities from across the entire territory of Bosnia and Herzegovina. Our goal is to consolidate all relevant business information in one place, making it easily accessible to all business entities and individuals in Bosnia and Herzegovina, the region, and beyond.",
            aboutTextFourth:
              "Our vision is to maintain a reputable position in the business publishing industry in Bosnia and Herzegovina, recognized primarily for the quality, timeliness, and pricing of our services. To continuously achieve this, we have oriented ourselves to operate in step with the development of modern technologies, aiming for year-on-year growth in the quality of our business publications and expanding our network of users and advertisers. We are prepared to launch new business publications according to market demands, such as specialized brochures, special professional supplements, and periodic and monthly bulletins and magazines.",
            aboutLandmark: "Telekom – BL, Banja Luka",
          },
          contactUsPage: {
            contactTitle: "Contact Us",
            contactFormCompanyName: "Company name",
            contactFormContactPerson: "Contact person",
            contcatFormEmail: "E-mail",
            contactFormMessage: "Message",
            contactSuccessMessage:
              "Your message has been successfully sent. We will respond to you as soon as possible.",
            contactSuccessTitle: "Thanks!",
          },
          orderRequestPage: {
            orderTitle: "Order request",
            orderPackageOne: "Package 1",
            orderPackageTwo: "Package 2",
            orderPackageThree: "Package 3",
            orderPackageOneText:
              "Updating and publishing the customers information in the Business Directory of Bosnia and Herzegovina (electronic edition); advertisement on the website poslovniimenik.net (logo, information, and link); publishing the same advertisement in the Catalog of the Business Directory of Bosnia and Herzegovina",
            orderPackageTwoText:
              "Updating and publishing the customer's information in the Business Directory of Bosnia and Herzegovina (electronic edition); advertisement on the website poslovniimenik.net (logo, information, and link); publishing the same advertisement in the Catalog of the Business Directory of Bosnia and Herzegovina; banner advertisement.",
            orderPackageThreeText:
              "Business Directory of Bosnia and Herzegovina digital edition.",
            orderNoteTitle: "Note:",
            orderNoteText:
              "The services of the package last for one year from the day of publishing. VAT is not included in the price. For other services and products, please contact our customer service. The ordered services and products from the mentioned packages will be realized and sent no later than five days from the payment date.",
            orderNoteSub:
              "Please note that the grammar and formatting have been adjusted for clarity and readability.",
            orderFormCompanyName: "Company name",
            orderFormTaxId: "TAX-ID",
            orderFormEmail: "E-mail",
            orderFormPhoneNumber: "Phone number",
            orderFormPlace: "Place",
            orderFormStreet: "Street",
            orderFormHomeNumber: "Street number",
            orderFormMessage: "Message",
          },
          buttons: {
            search: "Search",
            send: "Send",
            call: "Call Now",
            order: "Order Now",
            download: "Download",
            downloading: "Downloading...",
            orderOnline: "Order online",
            orderByPhone: "Order by phone",
            orderByEmail: "Order by e-mail",
            close: "Close",
            clearSearch: "Clear search",
          },
          searchResultLayout: {
            cardPremium: "Premium",
            cardPlace: "Place:",
            cardStreet: "Street:",
            cardWeb: "Web:",
            cardPhone: "Phone:",
            cardEmail: "Е-mail:",
            cardAddress: "Address:",
          },
          fullDetailsModal: {
            cardPremium: "Premium",
            cardPlace: "Place:",
            cardStreet: "Street:",
            cardNumber: "Number:",
            cardWeb: "Web",
            cardPhone: "Phone:",
            cardEmail: "E-mail:",
            cardWorkingTimes: "Radno vrjeme:",
            cardWorkingTimesClosed: "Closed",
            cardWorkingTimesOpen: "Open 24h",
          },
          subheader: {
            callNow: "Call Now",
            order: "Order",
          },
          languageSwitcher: {
            serbianLatinLanguage: "Bosnia",
            englishLagnuage: "English",
            serbianCyrlLanguage: "Serbian (cyrillic)",
          },
          weekDays: {
            monday: "Monday",
            tuesday: "Tuesday",
            wednesday: "Wednesday",
            thursday: "Thursday",
            friday: "Friday",
            saturday: "Saturday",
            sunday: "Sunday",
            hours: "h",
          },
          notificationMessages: {
            searchErrorMessage:
              "You need to enter a minimum of 3 characters in the field to display the results!",
            fullDetailsModalError:
              "An error occurred while collecting data. Please try again!",
          },
          termsAndContitions: {
            accept: "I accept the terms and conditions.",
            description:
              'By clicking the "Send" button, I confirm that you may inform me about current offers in the future and that I have read and understood the privacy statement.',
            error: "Please accept the terms and conditions.",
          },
          promoteBusinessSection: {
            title: "Promote your business!",
            titlePremium: "Promote your business(premium)!",
            description: "Your business description!",
            companyTitle: "Your company title",
          },
        },
      },
      rs: {
        translation: {
          cookieConsent: {
            title:
              "Ova web stranica koristi kolačiće kako bi poboljšala korisničko iskustvo.",
            description:
              "Koristimo kolačiće kako bismo analizirali promet na web stranici i optimizirali vaše iskustvo na web stranici. Prihvatanjem naše potrebe kolačića, vaši podaci će biti agregirani sa svim ostalim korisničkim podacima.",
            understand: "Razumijem",
          },
          validation: {
            validationCompanyName: "Polje za naziv kompanije je obavezno",
            validationTaxId: "Polje za PIB je obavezno",
            validationEmail: "E-mail polje je obavezno",
            validationPhoneNumber: "Polje za broj telefona je obavezno",
            validationMessage: "Polje za poruku je obavezno",
            validationPackage: "Izaberite paket",
          },
          messageKey: {
            orderRequest_Pending: "Slanje zahtjeva za porudžbinu...",
            orderRequest_Success: "Zahtjev za porudžbinu je uspješno poslan!",
            orderRequest_Error:
              "Nažalost, slanje zahtjeva nije uspjelo. Molimo provjerite vašu internet vezu i pokušajte ponovo.",

            advertisementRequest_Pending: "Slanje zahtjeva za oglašavanje...",
            advertisementRequest_Success:
              "Zahtjev za oglašavanje je uspješno poslan!",
            advertisementRequest_Error:
              "Nažalost, slanje zahtjeva nije uspjelo. Molimo provjerite vašu internet vezu i pokušajte ponovo.",

            updateDataRequest_Pending: "Slanje zahtjeva za ažuriranje...",
            updateDataRequest_Success:
              "Zahtjev za ažuriranje je uspješno poslan!",
            updateDataRequest_Error:
              "Nažalost, slanje zahtjeva nije uspjelo. Molimo provjerite vašu internet vezu i pokušajte ponovo.",

            contactRequest_Pending: "Vaša poruka se šalje... ",
            contactRequest_Success:
              "Vaš zahtjev je uspješno poslan! Hvala vam što ste nas kontaktirali. Potrudit ćemo se da vam odgovorimo u najkraćem mogućem roku.",
            contactRequest_Error:
              "Nažalost, slanje poruke nije uspjelo. Molimo provjerite vašu internet vezu i pokušajte ponovo.",
          },
          header: {
            homePage: "Početna",
            services: "Usluge",
            updateData: "Ažurirajte podatke",
            advertisement: "Oglašavanje",
            digitalMarketing: "Digitalni marketing",
            editions: "Izdanja",
            aboutUs: "O nama",
            contact: "Kontakt",
            companyNameInput: "Unesite naziv firme, uslugu/proizvod, mjesto...",
            advanceSearchLabel: "Napredno pretraživanje Poslovnog imenika BiH",
            categoryInput: "Djelatnost",
            subCategoryInput: "Poddjelatnost",
            place: "Mjesto",
          },
          footer: {
            footerDescription:
              "Osnovna djelatnost naše firme je poslovno izdavaštvo na teritoriji Bosne i Hercegovine. Naša redakcija je pokrenula mnoga visokotiražna specijalizovana poslovna izdanja kao što su: Telefonski - telefax imenik BiH, Telefonoteka, Poslovni imenik BiH, 300 najuspješnijih firmi u BiH, Katalog Poslovnog imenika BiH, kao i odgovarajuće elektronske publikacije na CD-u, te prateća internet izdanja za navedene naslove.",
            footerFastLinksTitle: "Brzi linkovi",
            footerFastLinkHome: "Početna",
            footerFastLinkServices: "Usluge",
            footerFastLinkUpdatingData: "-Ažurirajte podatke",
            footerFastLinkAdvertisement: "-Oglašavanje",
            footerFastLinkDigitalMarketing: "-Digitalni marketing",
            footerFastLinkEditions: "Izdanja",
            footerFastLinkAbout: "O nama",
            footerFastLinkContact: "Kontakt",
          },
          homePage: {
            resultsPerPage: "Rezultata po stranici",
          },
          updatingDataPage: {
            updatingDataTitle: "Ažurirajte podatke",
            updatingDataText:
              "Upis novih podataka podrazumijeva ažuriranje postojećih, unos novih i brisanje starih nevažećih podataka u bazi Poslovnog imenika BiH. Ovu aktivnost sprovodi izdavač na osnovu informacija pribavljenih terenskim radom, telefonskim anketama, kao i podatke pribavljene preko online forme na ovom vebsajtu.",
            updatingDataFormCompanyName: "Naziv firme",
            updatingDataFormPIB: "PIB",
            updatingDataFormEmail: "E-mail",
            updatingDataFormPhoneNumber: "Broj telefona",
            updatingDataFormPlace: "Mjesto",
            updatingDataFormStreet: "Ulica",
            updatingDataFormHomeNumber: "Broj",
          },
          advertisementPage: {
            advertisementTitle: "Oglašavanje",
            advertisementText:
              "Obezbjeđujemo razne vrste oglašavanja i kreiramo set usluga prema potrebama naših klijenata. Za kompletan asortiman naših usluga i personalizovanu izradu seta usluga za oglašavanje neophodno je da stupite u kontantakt s našim agentima prodaje, a preko sledeće kontakt forme možete da naručite neke od naših najpopularnijih paketa usluga.",
            advertisementFormCompanyName: "Naziv firme",
            advertisementFormPIB: "PIB",
            advertisementFormEmail: "E-mail",
            advertisementFormPhoneNumber: "Broj telefona",
            advertisementFormPlace: "Mjesto",
            advertisementFormStreet: "Ulica",
            advertisementFormHomeNumber: "Broj",
          },
          digitalMarketingPage: {
            digitalMarketingTitle: "Digitalni marketing",
            digitalMarketingText:
              "Obezbjeđujemo sve što je neophodno privrednim subjektima za poslovno informisanje, oglašavanje i digitalnu transformaciju. Posredstvom inteligentnih softverskih tehnologija pružamo kvalitetna, efikasna i pristupačna rješenja za unapređivanje digitalnog poslovanja i porast poslovnog uspjeha.",
            digitalMarketingTextSecond:
              "Analiziramo Vaše poslovne procese i informacione sisteme, te predlažemo optimalna rješenja za digitalnu transformaciju, integraciju, automatizaciju i unapređivanje svih segmenata poslovanja. Naša rješenja su jedinstvena, dinamična i skalabilna, te potpuno prilagođena Vašim potrebama i ciljevima. Sve naše usluge prate najnovije tehnološke trendove i primjenjuju se u skladu s najboljim praksama. Bez obzira da li se radi o novom projektu, proširenju postojećeg poslovanja ili povećanju vidljivosti Vaše online prisutnosti, mi smo tu da Vam pomognemo.",
            digitalMarketingTextThird:
              "Kontaktirajte nas i zatražite besplatnu procjenu mogućnosti Vašeg digitalnog poslovnog unaprijeđivanja, a mi ćemo Vam dati prijedloge za digitalni poslovni razvoj prilagođen Vašim potrebama i ciljevima.",
          },
          editionsPage: {
            catalogTitle: "Poslovni imenik Bosne i Hercegovine - Katalog",
            catalogTextFirst:
              "Poslovni imenik Bosne i Hercegovine (štampano izdanje) je do 2016. god. bio najčitanija i najprodavanija publikacija poslovnih informacija na području Bosne i Hercegovine. Duga tradicija našeg poslovanja poznata je svim firmama, organizacijama i institucijama koje su posredno ili neposredno koristili naša godišnja izdanja.",
            catalogText:
              "Poslovni imenik Bosne i Hercegovine (štampano izdanje) je do 2016. god. bio najčitanija i najprodavanija publikacija poslovnih informacija na području Bosne i Hercegovine. Duga tradicija našeg poslovanja poznata je svim firmama, organizacijama i institucijama koje su posredno ili neposredno koristili naša godišnja izdanja.",
            catalogTextSecond:
              "Savremena elektronska i tehnološka dostignuća upravljala su promjenama u mnogim poslovnim sistemima, što je slučaj i kod Poslovnog imenika Bosne i Hercegovine. Do sada poznati Poslovni imenik BiH (knjižno izdanje) koji se od 2016. god. više ne štampa, redizajniran je i modernizovan u novu publikaciju Poslovni imenik BiH – Katalog.",
            catalogTextThird:
              "Osnovu Poslovnog imenika BiH – Kataloga čine firme, organizacije i institucije sa teritorije Bosne i Hercegovine, koje se ovim putem kolorno i tekstualno oglašavaju. Kao i za sva ostala izdanja Poslovnog imenika Bosne i Hercegovine – Katalog i za ovo slijedi raniji ustanovljeni koncept direktnog marketinga, gdje se u prvi plan stavljaju informacije o aktivnim pravnim subjektima iz Bosne i Hercegovine. U Katalogu svi oglasi pravnih subjekata sortirani su po srodnim djelatnostima, a oglašivači sa logotipima u nastavku oglasa iste djelatnosti, sortirani su po abecedi. Više detalja o firmama i institucijama možete pogledati u Katalogu (PDF formatu), a cijelu bazu podataka Poslovnog imenika BiH potražite na sajtu www.poslovniimenik.net.",
            cdTitle: "Poslovni imenik BiH - elektronsko izadnje",
            cdText:
              "U odnosu na online, a posebno na štampano izdanje, Poslovni imenik Bosne i Hercegovine - elektronsko izdanje, nudi mnoge prednosti. One su naročito izražene kod pretraživanja i sortiranja sadržaja jer je omogućena pretraga po svim parametrima pojedinačno, kombinovane pretrage na dva ili više načina te snimanje i čuvanje pretraga.",
            cdTextSecond:
              "Druga značajna prednost je mogućnost korišćenja podataka za digitalni marketing, bilo da su u pitanju društvene mreže ili direktni marketing. Baza podataka elektronskog Poslovnog imenika BiH se osvježava svakodnevno i dopunjava novim informacijama vezanim za postojeće i nove firme ili institucije.",
            cdTextThird:
              "Za svaku firmu ili instituciju u bazi postoje osnovni podaci: - Naziv firme ili institucije; - Podaci o djelatnosti firme ili institucije; - Adresa firme ili institucije: ulica, broj, mjesto, poštanski broj, entitet i tel. i pozivni broj; - Brojevi telefona, telefaxa, e-mail adrese; - Web adrese firme ili institucije.",
            cdTextFourth:
              "Kupovinom elektronskog izdanja Poslovnog imenika BiH i unosom Vaše firme u bazu, ostvarujete pravo na upis i objavu podataka u izdanjima Poslovnog imenika Bosne i Hercegovine (internet i elektronsko izdanje), kao i pravo na besplatno redovno ažuriranje, izmjene ili dopune Vaših podataka preko interneta u trajanju jednogodišnje pretplate.",
            cdTextFifth:
              "Vjerujemo da će Vam ovo elektronsko izdanje Poslovnog imenika BiH omogućiti da sve podatke neophodne za svakodnevnu komunikaciju lako pronalazite i na taj način stupite u poslovni kontakt postojećih pravnih subjekata u Bosni i Hercegovini.",
            onlineTitle: "Online Poslovni imenik Bosne i Hercegovine",
            onlineText:
              "Od svih naših poslovnih izdanja najvažnije mjesto zauzima internet prezentacija Poslovnog imenika Bosne i Hercegovine. Elektronska prezentacija predstavlja ogledalo Vaše firme i veoma je pristupačan, povoljan i moderan oblik reklamiranja koji može mnogo da doprinese Vašem uspješnijem poslovanju.",
            onlineTextSecond:
              "Online izdanje Poslovnog imenika BiH je koncipirano kao centar raznovrsnih poslovnih djelatnosti. Sadržaj internet prezentacije www.poslovniimenik.net dostupan je svim korisnicima internet usluge na pregled, te je omogućena brza pretraga podataka posredstvom većeg broja različitih parametara. Ogroman broj ljudi i poslovnih korisnika svakodnevno posjećuje našu internet prezentaciju, što je od velike koristi kako našim posjetiocima tako i  korisnicima  naših usluga.",
            onlineTextThird:
              "Prezentovanjem Vaše firme, institucije ili organizacije na našoj internet prezentaciji pridružujete se svim oglašivačima koji su već putem oglasa istakli svoje podatke i na taj način omogućili stotinama hiljada zainteresovanih posjetilaca da imaju detaljan pregled Vaše firme i Vaše djelatnosti.",
            onlineTextFourth:
              "Online izdanje Poslovnog imenika BiH u paketu sa štampanim i elektronskim izdanjem ima zadatak da osnovne poslovne podatke prenese do svih kategorija korisnika i da svojom dinamikom utiče na protok informacija.",
            onlineTextFifth:
              "Sve informacije koje izdavač prikupi terenskim ili telefonskim anketiranjem kao i informacije iz drugih izvora redovno se ažuriraju u bazi podataka Poslovnog imenika BiH što podrazumijeva da će podaci o Vašoj firmi biti vrlo brzo i na internet prezentaciji Poslovnog imenika BiH.",
          },
          aboutUsPage: {
            aboutTitle: "O nama",
            aboutText:
              "Osnovna djelatnost naše firme je poslovno izdavaštvo na teritoriji Bosne i Hercegovine. Naša redakcija je pokrenula mnoga visokotiražna specijalizovana poslovna izdanja kao što su: Telefonski - telefax imenik BiH, Telefonoteka, Poslovni imenik BiH, 300 najuspješnijih firmi u BiH, Katalog Poslovnog imenika BiH, kao i odgovarajuće elektronske publikacije na CD-u, te prateća internet izdanja za navedene naslove.",
            aboutTextSecond:
              "Poslovna strategija koju koristimo je direktni marketing i direktna prodaja. Posredstvom tih poslovnih strategija izdavač Poslovnog imenika Bosne i Hercegovine potpuno samostalno organizuje svoje komercijalne i marketinške aktivnosti, kao i pripremu, te uređivanje i publikovanje svih svojih poslovnih izdanja.",
            aboutTextThird:
              "Navedeni poslovni koncept formirao je i našu misiju kao aktivno i permanentno ažuriranje baze podataka privrednih subjekata sa cjelokupne teritorije Bosne i Hercegovine, čineći sve te poslovne podatke objedinjene na jednom mjestu, te brzo i lako dostupne svim poslovnim subjektima kao i civilnim licima u BiH, regionu i šire.",
            aboutTextFourth:
              "Naša vizija je da zauvijek očuvamo renomirano mjesto u poslovnom izdavaštvu na teritoriji Bosne i Hercegovine, prepoznatljivo prvenstveno po kvalitetu, rokovima i cijenama usluga. Da bi to kontinuelno postizali, orijentisali smo se da poslujemo u korak s razvojem savremenih tehnologija kako bi iz godine u godinu postizali rast kvaliteta naših poslovnih izdanja, te iz dana u dan širimo mrežu naših korisnika i oglašivača. Prema zahtjevima tržišta spremni smo pokretati nova poslovna izdanja kao što su specijalizove brošure, posebni stručni dodaci, te periodični i mjesečni bilteni i časopisi.",
            aboutLandmark: "Telekom – BL, Banja Luka",
          },
          contactUsPage: {
            contactTitle: "Kontaktirajte nas",
            contactFormCompanyName: "Naziv firme",
            contactFormContactPerson: "Kontakt osoba",
            contactFormEmail: "E-mail",
            contactFormMessage: "Poruka",
            contactSuccessMessage:
              "Vaša poruka je uspješno poslata. Odgovorićemo Vam u najkraćem mogućem roku.",
            contactSuccessTitle: "Hvala!",
          },
          orderRequestPage: {
            orderTitle: "Zahtjev za naručivanje",
            orderPackageOne: "Paket 1",
            orderPackageTwo: "Paket 2",
            orderPackageThree: "Paket 3",
            orderPackageOneText:
              "Ažuriranje i objavljivanje informacija o klijentu u Poslovnom imeniku Bosne i Hercegovine (elektronsko izdanje); Oglas na web stranici poslovniimenik.net (logo, informacije i link); Objavljivanje istog oglasa u Katalogu Poslovnog imenika Bosne i Hercegovine.",
            orderPackageTwoText:
              "Ažuriranje i objavljivanje informacija o kupcu u Poslovnom imeniku Bosne i Hercegovine (elektronsko izdanje); Oglas na web stranici poslovniimenik.net (logo, informacije i link); Objavljivanje istog oglasa u Katalogu Poslovnog imenika Bosne i Hercegovine; Oglas na baneru.",
            orderPackageThreeText: "Poslovni imenik BiH digitalno izdanje.",
            orderNoteTitle: "Napomena:",
            orderNoteText:
              "Usluge paketa traju jednu godinu od dana objavljivanja. U cijenu nije uračunat PDV. Za ostale naše usluge i proizvode kontaktirajte našu službu za korisnike. Naručene usluge i proizvodi iz navedenih paketa realizuju se i šalju najkasnije pet dana od dana uplate.",
            orderNoteSub:
              "Molim vas imajte na umu da su gramatika i formatiranje prilagođeni radi jasnoće i čitljivosti.",
            orderFormCompanyName: "Naziv firme",
            orderFormTaxId: "PIB",
            orderFormEmail: "E-mail",
            orderFormPhoneNumber: "Broj telefona",
            orderFormPlace: "Mjesto",
            orderFormStreet: "Ulica",
            orderFormHomeNumber: "Broj",
            orderFormMessage: "Poruka",
          },
          buttons: {
            search: "Pretraga",
            send: "Pošaljite",
            call: "Pozovite",
            order: "Naručite odmah",
            download: "Preuzmite",
            downloading: "Preuzimam...",
            orderOnline: "Naručite online",
            orderByPhone: "Naručite telefonom",
            orderByEmail: "Naručite preko e-maila",
            close: "Zatvori",
            clearSearch: "Očisti pretragu",
          },
          searchResultLayout: {
            cardPremium: "Premium",
            cardPlace: "Grad-mjesto:",
            cardStreet: "Ulica:",
            cardWeb: "Web",
            cardPhone: "Telefon:",
            cardEmail: "E-mail:",
            cardAddress: "Adresa:",
          },
          fullDetailsModal: {
            cardPremium: "Premium",
            cardPlace: "Grad-mjesto:",
            cardStreet: "Ulica:",
            cardNumber: "Broj:",
            cardWeb: "Web",
            cardPhone: "Telefon:",
            cardEmail: "E-mail:",
            cardWorkingTimes: "Working time:",
            cardWorkingTimesClosed: "Zatvoreno",
            cardWorkingTimesOpen: "Otvoreno 24h",
          },
          subheader: {
            callNow: "Pozovite odmah",
            order: "Naručite",
          },
          languageSwitcher: {
            serbianLatinLanguage: "Bosanski",
            englishLagnuage: "Engleski",
            serbianCyrlLanguage: "Srpski (ćirilica)",
          },
          weekDays: {
            monday: "Ponedeljak",
            tuesday: "Utorak",
            wednesday: "Sreda",
            thursday: "Četvrtak",
            friday: "Petak",
            saturday: "Subota",
            sunday: "Nedelja",
            hours: "čas",
          },
          notificationMessages: {
            searchErrorMessage:
              "Potrebno je uneti minimalno 3 karaktera u polje da bi se prikazali rezultati!",
            fullDetailsModalError:
              "Došlo je do greške prilikom prikupljanja podataka. Molimo Vas pokušajte ponovo!",
          },
          termsAndContitions: {
            accept: "Prihvatam uslove",
            description:
              'Klikom na dugme "Pošaljite" potvrđujem da me ubuduće obavještavate o trenutnim ponudama i potvrđujem da sam pročitao/la i razumio/la izjavu o privatnosti.',
            error: "Molimo Vas da prihvatite uslove i odredbe.",
          },
          promoteBusinessSection: {
            title: "Promovišite svoj posao!",
            titlePremium: "Promovišite svoj posao (premium)!",
            description: "Opis vašeg posla!",
            companyTitle: "Naziv vaše kompanije",
          },
        },
      },
      rsCyrl: {
        translation: {
          cookieConsent: {
            title:
              "Ова Веб страница користи колачиће како би побољшала корисничко искуство.",
            description:
            "Користимо колачиће како бисмо анализирали промет на wеб страници и оптимизирали ваше искуство на wеб страници. Прихватањем наше употребе колачића, ваши подаци ће бити агрегирани са свим осталим корисничким подацима.",
            understand: "Разумијем",
          },
          validation: {
            validationCompanyName: "Поље за назив компаније је обавезно",
            validationTaxId: "Поље за ПИБ је обавезно",
            validationEmail: "Е-маил поље је обавезно",
            validationPhoneNumber: "Поље за број телефона је обавезно",
            validationMessage: "Поље за поруку је обавезно",
            validationPackage: "Изаберите пакет",
          },
          messageKey: {
            orderRequest_Pending: "Слање захтјева за поруџбину...",
            orderRequest_Success: "Захтјев за поруџбину је успјешно послан!",
            orderRequest_Error:
              "Нажалост, слање захтјева није успјело. Молимо провјерите вашу интернет везу и покушајте поново.",

            advertisementRequest_Pending: "Слање захтјева за оглашавање...",
            advertisementRequest_Success:
              "Захтјев за оглашавање је успјешно послан!",
            advertisementRequest_Error:
              "Нажалост, слање захтјева није успјело. Молимо провјерите вашу интернет везу и покушајте поново.",

            updateDataRequest_Pending: "Слање захтјева за ажурирање...",
            updateDataRequest_Success:
              "Захтјев за ажурирање је успјешно послан!",
            updateDataRequest_Error:
              "Нажалост, слање захтјева није успјело. Молимо провјерите вашу интернет везу и покушајте поново.",

            contactRequest_Pending: "Ваша порука се шаље...",
            contactRequest_Success:
              "Ваш захтјев је успјешно послан! Хвала вам што сте нас контактирали. Потрудит ћемо се да вам одговоримо у најкраћем могућем року.",
            contactRequest_Error:
              "Нажалост, слање поруке није успјело. Молимо провјерите вашу интернет везу и покушајте поново.",
          },
          header: {
            homePage: "Почетна",
            services: "Услуге",
            updateData: "Ажурирајте податке",
            advertisement: "Оглашавање",
            digitalMarketing: "Дигитални маркетинг",
            editions: "Издања",
            aboutUs: "О нама",
            contact: "Контакт",
            companyNameInput: "Унесите назив фирме, услугу/производ, мјесто...",
            advanceSearchLabel: "Напредно претраживање Пословног именика БиХ",
            categoryInput: "Дјелатност",
            subCategoryInput: "Поддјелатност",
            place: "Мјесто",
          },
          footer: {
            footerDescription:
              "Основна дјелатност наше фирме је пословно издаваштво на територији Босне и Херцеговине. Наша редакција је покренула многа високотиражна специјализована пословна издања као што су: Телефонски-телефаx именик БиХ, Телефонотека, Пословни именик БиХ, 300 најуспјешнијих фирми у БиХ, Каталог Пословног именика БиХ, као и одговарајуће електронске публикације на ЦД-у, те пратећа интернет издања за наведене наслове.",
            footerFastLinksTitle: "Брзи линкови",
            footerFastLinkHome: "Почетна",
            footerFastLinkServices: "Услуге",
            footerFastLinkUpdatingData: "-Ажурирајте податке",
            footerFastLinkAdvertisement: "-Оглашавање",
            footerFastLinkDigitalMarketing: "-Дигитални маркетинг",
            footerFastLinkEditions: "Издања",
            footerFastLinkAbout: "О нама",
            footerFastLinkContact: "Контакт",
          },
          homePage: {
            resultsPerPage: "Резултата по страници",
          },
          updatingDataPage: {
            updatingDataTitle: "Ажурирајте податке",
            updatingDataText:
              "Упис нових података подразумијева ажурирање постојећих, унос нових и брисање старих неважећих података у бази Пословног именика БиХ. Ову активност спроводи издавач на основу информација прибављених теренским радом, телефонским анкетама, као и податке прибављене преко онлајн форме на овом вебсајту.",
            updatingDataFormCompanyName: "Назив фирме",
            updatingDataFormPIB: "ПИБ",
            updatingDataFormEmail: "Е-маил",
            updatingDataFormPhoneNumber: "Број телефона",
            updatingDataFormPlace: "Мјесто",
            updatingDataFormStreet: "Улица",
            updatingDataFormHomeNumber: "Број",
          },
          advertisementPage: {
            advertisementTitle: "Оглашавање",
            advertisementText:
              "Обезбјеђујемо разне врсте оглашавања и креирамо сет услуга према потребама наших клијената. За комплетан асортиман наших услуга и персонализовану израду сета услуга за оглашавање неопходно је да ступите у контантакт с нашим агентима продаје, а преко следеће контакт форме можете да наручите неке од наших најпопуларнијих пакета услуга.",
            advertisementFormCompanyName: "Назив фирме",
            advertisementFormPIB: "ПИБ",
            advertisementFormEmail: "Е-маил",
            advertisementFormPhoneNumber: "Број телефона",
            advertisementFormPlace: "Мјесто",
            advertisementFormStreet: "Улица",
            advertisementFormHomeNumber: "Број",
          },
          digitalMarketingPage: {
            digitalMarketingTitle: "Digitalni marketing",
            digitalMarketingText:
              "Обезбјеђујемо све што је неопходно привредним субјектима за пословно информисање, оглашавање и дигиталну трансформацију. Посредством интелигентних софтверских технологија пружамо квалитетна, ефикасна и приступачна рјешења за унапређивање дигиталног пословања и пораст пословног успјеха.",
            digitalMarketingTextSecond:
              "Анализирамо Ваше пословне процесе и информационе системе, те предлажемо оптимална рјешења за дигиталну трансформацију, интеграцију, аутоматизацију и унапређивање свих сегмената пословања. Наша рјешења су јединствена, динамична и скалабилна, те потпуно прилагођена Вашим потребама и циљевима. Све наше услуге прате најновије технолошке трендове и примјењују се у складу с најбољим праксама. Без обзира да ли се ради о новом пројекту, проширењу постојећег пословања или повећању видљивости Ваше онлајн присутности, ми смо ту да Вам помогнемо.",
            digitalMarketingTextThird:
              "Контактирајте нас и затражите бесплатну проћену могућности Вашег дигиталног пословног унапријеђивања, а ми ћемо Вам дати приједлоге за дигитални пословни развој прилагођен Вашим потребама и циљевима.",
          },
          editionsPage: {
            catalogTitle: "Пословни именик Босне и Херцеговине - Каталог",
            catalogTextFirst:
              "Пословни именик Босне и Херцеговине (штампано издање) је до 2016. год. био најчитанија и најпродаванија публикација пословних информација на подручју Босне и Херцеговине. Дуга традиција нашег пословања позната је свим фирмама, организацијама и институцијама које су посредно или непосредно користили наша годишња издања.",
            catalogText:
              "Пословни именик Босне и Херцеговине (штампано издање) је до 2016. год. био најчитанија и најпродаванија публикација пословних информација на подручју Босне и Херцеговине. Дуга традиција нашег пословања позната је свим фирмама, организацијама и институцијама које су посредно или непосредно користили наша годишња издања.",
            catalogTextSecond:
              "Савремена електронска и технолошка достигнућа управљала су промјенама у многим пословним системима, што је случај и код Пословног именика Босне и Херцеговине. До сада познати Пословни именик БиХ (књижно издање) који се од 2016. год. више не штампа, редизајниран је и модернизован у нову публикацију Пословни именик БиХ – Каталог.",
            catalogTextThird:
              "Основу Пословног именика БиХ – Каталога чине фирме, организације и институције са територије Босне и Херцеговине, које се овим путем колорно и текстуално оглашавају. Као и за сва остала издања Пословног именика Босне и Херцеговине – Каталог и за ово слиједи ранији установљени концепт директног маркетинга, гдје се у први план стављају информације о активним правним субјектима из Босне и Херцеговине. У Каталогу сви огласи правних субјеката сортирани су по сродним дјелатностима, а оглашивачи са логотипима у наставку огласа исте дјелатности, сортирани су по абецеди. Више детаља о фирмама и институцијама можете погледати у Каталогу (ПДФ формату), а цијелу базу података Пословног именика БиХ потражите на сајту poslovniimenik.net.",
            cdTitle: "Пословни именик БиХ - електронско издање",
            cdText:
              "У односу на онлајн, а посебно на штампано издање, Пословни именик Босне и Херцеговине - електронско издање, нуди многе предности. Оне су нарочито изражене код претраживања и сортирања садржаја јер је омогућена претрага по свим параметрима појединачно, комбиноване претраге на два или више начина те снимање и чување претрага.",
            cdTextSecond:
              "Друга значајна предност је могућност коришћења података за дигитални маркетинг, било да су у питању друштвене мреже или директни маркетинг. База података електронског Пословног именика БиХ се освјежава свакодневно и допуњава новим информацијама везаним за постојеће и нове фирме или институције.",
            cdTextThird:
              "За сваку фирму или институцију у бази постоје основни подаци: - Назив фирме или институције; - Подаци о дјелатности фирме или институције; - Адреса фирме или институције: улица, број, мјесто, поштански број, ентитет и тел. и позивни број; - Бројеви телефона, телефаxа, е-маил адресе; - Веб адресе фирме или институције.",
            cdTextFourth:
              "Куповином електронског издања Пословног именика БиХ и уносом Ваше фирме у базу, остварујете право на упис и објаву података у издањима Пословног именика Босне и Херцеговине (интернет и електронско издање), као и право на бесплатно редовно ажурирање, измјене или допуне Ваших података преко интернета у трајању једногодишње претплате.",
            cdTextFifth:
              "Вјерујемо да ће Вам ово електронско издање Пословног именика БиХ омогућити да све податке неопходне за свакодневну комуникацију лако проналазите и на тај начин ступите у пословни контакт постојећих правних субјеката у Босни и Херцеговини.",
            onlineTitle: "Онлајн Пословни именик Босне и Херцеговине",
            onlineText:
              "Од свих наших пословних издања најважније мјесто заузима интернет презентација Пословног именика Босне и Херцеговине. Електронска презентација представља огледало Ваше фирме и веома је приступачан, повољан и модеран облик рекламирања који може много да допринесе Вашем успјешнијем пословању.",
            onlineTextSecond:
              "Онлајн издање Пословног именика БиХ је конципирано као центар разноврсних пословних дјелатности. Садржај интернет презентације poslovniimenik.net доступан је свим корисницима интернет услуге на преглед, те је омогућена брза претрага података посредством већег броја различитих параметара. Огроман број људи и пословних корисника свакодневно посјећује нашу интернет презентацију, што је од велике користи како нашим посјетиоцима тако и  корисницима  наших услуга.",
            onlineTextThird:
              "Презентовањем Ваше фирме, институције или организације на нашој интернет презентацији придружујете се свим оглашивачима који су већ путем огласа истакли своје податке и на тај начин омогућили стотинама хиљада заинтересованих посјетилаца да имају детаљан преглед Ваше фирме и Ваше дјелатности.",
            onlineTextFourth:
              "Онлајн издање Пословног именика БиХ у пакету са штампаним и електронским издањем има задатак да основне пословне податке пренесе до свих категорија корисника и да својом динамиком утиче на проток информација.",
            onlineTextFifth:
              "Све информације које издавач прикупи теренским или телефонским анкетирањем као и информације из других извора редовно се ажурирају у бази података Пословног именика БиХ што подразумијева да ће подаци о Вашој фирми бити врло брзо и на интернет презентацији Пословног именика БиХ.",
          },
          aboutUsPage: {
            aboutTitle: "О нама",
            aboutText:
              "Основна дјелатност наше фирме је пословно издаваштво на територији Босне и Херцеговине. Наша редакција је покренула многа високотиражна специјализована пословна издања као што су: Телефонски - телефаx именик БиХ, Телефонотека, Пословни именик БиХ, 300 најуспјешнијих фирми у БиХ, Каталог Пословног именика БиХ, као и одговарајуће електронске публикације на ЦД-у, те пратећа интернет издања за наведене наслове.",
            aboutTextSecond:
              "Пословна стратегија коју користимо је директни маркетинг и директна продаја. Посредством тих пословних стратегија издавач Пословног именика Босне и Херцеговине потпуно самостално организује своје комерцијалне и маркетиншке активности, као и припрему, те уређивање и публиковање свих својих пословних издања.",
            aboutTextThird:
              "Наведени пословни концепт формирао је и нашу мисију као активно и перманентно ажурирање базе података привредних субјеката са цјелокупне територије Босне и Херцеговине, чинећи све те пословне податке обједињене на једном мјесту, те брзо и лако доступне свим пословним субјектима као и цивилним лицима у БиХ, региону и шире.",
            aboutTextFourth:
              "Наша визија је да заувијек очувамо реномирано мјесто у пословном издаваштву на територији Босне и Херцеговине, препознатљиво првенствено по квалитету, роковима и цијенама услуга. Да би то континуелно постизали, оријентисали смо се да послујемо у корак с развојем савремених технологија како би из године у годину постизали раст квалитета наших пословних издања, те из дана у дан ширимо мрежу наших корисника и оглашивача. Према захтјевима тржишта спремни смо покретати нова пословна издања као што су специјализове брошуре, посебни стручни додаци, те периодични и мјесечни билтени и часописи.",
            aboutLandmark: "Телеком – БЛ, Бања Лука",
          },
          contactUsPage: {
            contactTitle: "Контактирајте нас",
            contactFormCompanyName: "Назив фирме",
            contactFormContactPerson: "Контакт особа",
            contactFormEmail: "Е-маил",
            contactFormMessage: "Порука",
            contactSuccessMessage:
              "Ваша порука је успјешно послата. Одговорићемо Вам у најкраћем могућем року.",
            contactSuccessTitle: "Хвала!",
          },
          orderRequestPage: {
            orderTitle: "Захтјев за наручивање",
            orderPackageOne: "Пакет 1",
            orderPackageTwo: "Пакет 2",
            orderPackageThree: "Пакет 3",
            orderPackageOneText:
              "Ажурирање и објављивање информација о клијенту у Пословном именику Босне и Херцеговине (електронско издање); Оглас на веб страници poslovniimenik.net (лого, информације и линк); Објављивање истог огласа у Каталогу Пословног именика Босне и Херцеговине.",
            orderPackageTwoText:
              "Ажурирање и објављивање информација о купцу у Пословном именику Босне и Херцеговине (електронско издање); Оглас на веб страници poslovniimenik.net (лого, информације и линк); Објављивање истог огласа у Каталогу Пословног именика Босне и Херцеговине; Оглас на банеру.",
            orderPackageThreeText: "Пословни именик БиХ дигитално издање.",
            orderNoteTitle: "Напомена:",
            orderNoteText:
              "Услуге пакета трају једну годину од дана објављивања. У цијену није урачунат ПДВ. За остале наше услуге и производе контактирајте нашу службу за кориснике. Наручене услуге и производи из наведених пакета реализују се и шаљу најкасније пет дана од дана уплате.",
            orderNoteSub:
              "Молим вас имајте на уму да су граматика и форматирање прилагођени ради јасноће и читљивости.",
            orderFormCompanyName: "Назив фирме",
            orderFormTaxId: "ПИБ",
            orderFormEmail: "Е-маил",
            orderFormPhoneNumber: "Број телефона",
            orderFormPlace: "Мјесто",
            orderFormStreet: "Улица",
            orderFormHomeNumber: "Број",
            orderFormMessage: "Порука",
          },
          buttons: {
            search: "Претрага",
            send: "Пошаљите",
            call: "Позовите",
            order: "Наручите одмах",
            download: "Преузмите",
            downloading: "Преузимам...",
            orderOnline: "Наручите онлајн",
            orderByPhone: "Наручите телефоном",
            orderByEmail: "Наручите преко е-маила",
            close: "Затвори",
            clearSearch: "Очисти претрагу",
          },
          searchResultLayout: {
            cardPremium: "Премиум",
            cardPlace: "Град-мјесто:",
            cardStreet: "Улица:",
            cardWeb: "Веб",
            cardPhone: "Телефон:",
            cardEmail: "Е-маил:",
            cardAddress: "Adresa:",
          },
          fullDetailsModal: {
            cardPremium: "Премиум",
            cardPlace: "Град-мјесто:",
            cardStreet: "Улица:",
            cardNumber: "Број:",
            cardWeb: "Веб",
            cardPhone: "Телефон:",
            cardEmail: "Е-маил:",
            cardWorkingTimes: "Радно врјеме:",
            cardWorkingTimesClosed: "Затворено",
            cardWorkingTimesOpen: "Отворено 24h",
          },
          subheader: {
            callNow: "Позовите одмах",
            order: "Наручите",
          },
          languageSwitcher: {
            serbianLatinLanguage: "Босански",
            englishLagnuage: "Енглески",
            serbianCyrlLanguage: "Српски (ћирилица)",
          },
          weekDays: {
            monday: "Понедељак",
            tuesday: "Уторак",
            wednesday: "Среда",
            thursday: "Четвртак",
            friday: "Петак",
            saturday: "Субота",
            sunday: "Недеља",
            hours: "час",
          },
          notificationMessages: {
            searchErrorMessage:
              "Потребно је унети минимално 3 карактера у поље да би се приказали резултати",
            fullDetailsModalError:
              "Дошло је до грешке приликом прикупљања података. Молимо Вас покушајте поново",
          },
          termsAndContitions: {
            accept: "Прихватам услове",
            description:
              'Кликом на дугме "Пошаљите" потврђујем да ме убудуће обавјештавате о тренутним понудама и потврђујем да сам прочитао/ла и разумио/ла изјаву о приватности.',
            error: "Молимо Вас да прихватите услове и одредбе.",
          },
          promoteBusinessSection: {
            title: "Промовишите свој посао!",
            titlePremium: "Промовишите свој посао (премиум)!",
            description: "Опис вашег посла!",
            companyTitle: "Назив ваше компаније",
          },
        },
      },
    },
  });

export default i18n;
